export default "__VITE_ASSET__A24LKdl6__"